import { PresentationTemplateSystemTemplateKind } from '@/types/schema';

interface PresentationTemplateNameFields {
  displayName: string;
  systemTemplateKind?: PresentationTemplateSystemTemplateKind | null;
}

export function getPresentationTemplateName(
  template: PresentationTemplateNameFields
) {
  if (
    template.systemTemplateKind ===
    PresentationTemplateSystemTemplateKind.Estate_360
  ) {
    return 'Estate360';
  }
  return template.displayName;
}

interface PresentationTemplateOwnershipFields {
  tenantID: string;
  luminaryOrganizationID?: string | null;
}

interface DefaultPresentationTemplateFields
  extends PresentationTemplateOwnershipFields {
  isDefault: boolean;
}

export function isPresentationTemplateOwnedByTenant(
  template: PresentationTemplateOwnershipFields,
  tenantId: string
): boolean {
  return template.tenantID === tenantId;
}

export function isPresentationTemplateSharedFromOrganization(
  template: PresentationTemplateOwnershipFields,
  tenantId: string
): boolean {
  return (
    Boolean(template.luminaryOrganizationID) &&
    !isPresentationTemplateOwnedByTenant(template, tenantId)
  );
}

export function isVisibleFirmPresentationTemplate(
  template: PresentationTemplateOwnershipFields,
  tenantId: string
): boolean {
  return (
    isPresentationTemplateOwnedByTenant(template, tenantId) ||
    Boolean(template.luminaryOrganizationID)
  );
}

/**
 * Returns the default used for new presentations. A published organization
 * default overrides the tenant's own default.
 */
export function getEffectiveDefaultPresentationTemplate<
  Template extends DefaultPresentationTemplateFields,
>(templates: Template[], tenantId: string): Template | undefined {
  return (
    templates.find(
      (template) =>
        template.isDefault &&
        isPresentationTemplateSharedFromOrganization(template, tenantId)
    ) ??
    templates.find(
      (template) =>
        template.isDefault &&
        isPresentationTemplateOwnedByTenant(template, tenantId)
    )
  );
}
